import { useContext } from 'react';
import { Medialink } from '../../../../../api/medialink';
import MedialinksContext from '../../_contexts/MedialinksContext';
import SharedMaterialsContext from '../../_contexts/SharedMaterialsContext';
import AssignmentSection from './AssignmentSection';
import MaterialSection from './MaterialSection';
import SharedMaterialSection from './SharedMaterialSection';
import MyAssignmentsContext from '../../../../../contexts/MyAssignmentsContext';
import ModuleContext from '../../../_contexts/ModuleContext';
import TableOfContentsContext from '../../_contexts/TableOfContentsContext';
import EmptyState from '../../../../../shared-components/EmptyState';
import { useTranslation } from 'react-i18next';
import Section from '@pelckmans/elementis/components/section';
import useSlideSets from '../../../hooks/useSlideSets';

const BASE = 'PAGES.TOC_LEVEL.SECTIONS.STUDENT';

function splitUpTeacherAndStudentMedialinks(medialinks: Medialink[]) {
  return medialinks.reduce(
    (acc: { teacherMedialinks: Medialink[]; studentMedialinks: Medialink[] }, medialink) => {
      if (medialink.group === 'teacher') {
        acc.teacherMedialinks.push(medialink);
      } else {
        acc.studentMedialinks.push(medialink);
      }
      return acc;
    },
    { teacherMedialinks: [], studentMedialinks: [] },
  );
}

export default function MaterialSections() {
  const { t } = useTranslation();
  const { selectedModule } = useContext(ModuleContext);
  const { selectedNode } = useContext(TableOfContentsContext);
  const { assignments } = useContext(MyAssignmentsContext);
  const { medialinks } = useContext(MedialinksContext);
  const { sharedMaterials } = useContext(SharedMaterialsContext);
  const { slideSets } = useSlideSets();

  if (!selectedModule || !selectedNode) return null;

  const assignmentsByModule = assignments.filter(
    a => a.moduleId === selectedModule?.id && a.nodeId === selectedNode?.id,
  );
  const { teacherMedialinks, studentMedialinks } = splitUpTeacherAndStudentMedialinks(medialinks);

  const isEmpty =
    assignmentsByModule.length === 0 &&
    teacherMedialinks.length === 0 &&
    studentMedialinks.length === 0 &&
    sharedMaterials.length === 0 &&
    slideSets.length === 0;

  if (isEmpty) {
    const isIntermediateLevel = (selectedNode?.nodes?.length ?? 0) > 0;
    if (selectedModule.isExerciseModule && isIntermediateLevel) return null;

    return (
      <Section title={t(`${BASE}.EMPTY_DIALOG.TITLE`)}>
        <EmptyState
          variant="list"
          headerTitle={t(`${BASE}.EMPTY_DIALOG.SUBTITLE`)}
          bodyText={t(`${BASE}.EMPTY_DIALOG.TEXT`)}
        />
      </Section>
    );
  }

  return (
    <div className="material-sections">
      <AssignmentSection assignments={assignmentsByModule} module={selectedModule} />
      <SharedMaterialSection medialinks={teacherMedialinks} />
      <MaterialSection medialinks={studentMedialinks} slideSets={slideSets} />
    </div>
  );
}
